(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/favorites/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/casino/favorites/assets/javascripts/prescript.js');
"use strict";


svs.components.casino = svs.components.casino || {};
svs.components.casino.data = svs.components.casino.data || {};
svs.components.casino.data.favorites = svs.components.casino.data.favorites || [];

 })(window);